import { Component, Input } from '@angular/core';

 
 export class SkyListToolbarSortComponent {
  
  public label: string;
  
  public field: string;
  
  public type: string;
  
  public descending: boolean;

 static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-list-toolbar-sort',
   template: ''
 }, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'label': [{ type: Input },],
'field': [{ type: Input },],
'type': [{ type: Input },],
'descending': [{ type: Input },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
